export enum ReportView {
  FULL_REPORT = 'fr',
  AC = 'ac',
  CR = 'cr',
  LG = 'lg',
  LQ = 'lq',
  MK = 'mk',
  OP = 'op',
  PU = 'pu',
  RP = 'rp',
  RV = 'rv',
  ST = 'st',
  FS = 'fs'
}

export function reportViewLabel(reportView: string): string {
  switch (reportView.toLowerCase()) {
    case 'fr':
      return 'Full Profile';
    case 'ac':
      return 'Additional Company Info';
    case 'cr':
      return 'Credit Risk Profile';
    case 'lg':
      return 'Legal Risk Profile';
    case 'lq':
      return 'Liquidity Risk Profile';
    case 'mk':
      return 'Market Risk Profile';
    case 'op':
      return 'Operational Risk Profile';
    case 'pu':
      return 'Pricing & Underwriting Risk Profile';
    case 'rp':
      return 'Reputational Risk Profile';
    case 'rv':
      return 'Reserving Risk Profile';
    case 'st':
      return 'Strategic Risk Profile';
    case 'fs':
      return 'Financial Summary';
    default:
      return '';
  }
}
